<span
  *ngIf="text && text.length"
  class="ui-label label-sm-semibold"
  (click)="onLabelClick()"
  [ngClass]="labelClass"
  [ngStyle]="activeCSS"
  [style.width]="labelWidth"
  [style.minWidth]="labelMinWidth"
  (mouseenter)="onLabelHover()"
  (mouseout)="onLabelHoverOut()"
>
  {{ text }}
</span>
